const gray900 = "#161E2E";
const white = "#FFFFFF";

export { gray900, white };
